import { Box, Button } from "@adfenix/alexandria";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { GenericError } from "components/GenericError";
import { Modal } from "components/Modal";
import SelectHqCombobox from "components/SelectHqCombobox";
import { selectHqModalState } from "atoms/selectedHqHoc";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { userSelectedHq } from "atoms/auth";
import { ConfigurationService } from "@adfenix/types";

const StyledBox = styled(Box)`
  min-height: 360px;
`;

interface ModalSelectHqProps {
  hqs?: ConfigurationService.HqAndDomainModel[];
}

export const ModalSelectHq = ({ hqs }: ModalSelectHqProps) => {
  const { t } = useTranslation();
  const [selectedHq, setSelectedHq] =
    useState<ConfigurationService.HqAndDomainModel>();
  const setModalState = useSetRecoilState(selectHqModalState);
  const setUserSelectedHq = useSetRecoilState(userSelectedHq);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const selectedHqGlobal = useRecoilValue(userSelectedHq);

  const backToMainPage = ["/order/", "/property/results"].some(p =>
    pathname.startsWith(p)
  );

  const handleApply = () => {
    setUserSelectedHq(selectedHq);

    if (backToMainPage) {
      navigate("/login");
    }

    setModalState(false);
  };

  if (status === "error") {
    return <GenericError />;
  }

  return (
    <Modal.Card>
      <Modal.Card.Head
        showClose={!!selectedHqGlobal}
        onClose={() => setModalState(false)}
      >
        <Modal.Card.Title>
          {t("listings.select.agency.modal.title")}
        </Modal.Card.Title>
      </Modal.Card.Head>

      <Modal.Card.Body>
        <StyledBox pX="s">
          <SelectHqCombobox
            setSelectedHq={hq => setSelectedHq(hq)}
            selectedHq={selectedHq}
            hqs={hqs}
          />
        </StyledBox>
      </Modal.Card.Body>

      <Box pY="xl2" display="flex" justifyContent="flex-end">
        <Button
          logLabel="hq-selector-submit-button"
          style={{ flexGrow: 1 }}
          color="primary"
          onClick={() => handleApply()}
          disabled={!selectedHq}
          data-testid="hq-selector-submit"
        >
          {t("listings.select.agency.modal.button")}
        </Button>
      </Box>
    </Modal.Card>
  );
};

export default ModalSelectHq;
